import { Outlet, useLocation } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";

const hideLayoutRoutes = ["/login"];

export default function AppLayout() {
  const location = useLocation();

  const hideLayout = hideLayoutRoutes.includes(location.pathname);

  return (
    <>
      {!hideLayout && <Header />}
      <Outlet />
      {/* {!hideLayout && <Footer />} */}
    </>
  );
}
